import { render } from "./MiezzButtonColor.vue?vue&type=template&id=e3ff1b3e&scoped=true&ts=true"
import script from "./MiezzButtonColor.vue?vue&type=script&lang=ts"
export * from "./MiezzButtonColor.vue?vue&type=script&lang=ts"

import "./MiezzButtonColor.vue?vue&type=style&index=0&id=e3ff1b3e&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ff1b3e"]])

export default __exports__